module.exports = __webpack_public_path__ + "static/media/sumavigroup ui-06.3575ccdd.png";